import { useNavigate } from "react-router-dom";
import {
  Eye,
  Phone,
  Mail,
  MapPin,
} from "lucide-react";

import ProviderStatusBadge from "./ProviderStatusBadge";
import getImageUrl from "../../../utils/imageUrl";
import "./ProviderTable.css";


function ProviderTable({
  providers,
  loading,
}) {

  const navigate = useNavigate();

  if (loading) {
    return (
      <div className="table-loading">
        Loading Providers...
      </div>
    );
  }

  if (!providers.length) {
    return (
      <div className="table-empty">
        <h2>No Providers Found</h2>
      </div>
    );
  }

  return (

    <div className="provider-table-container">

      <table className="provider-table">

        <thead>

          <tr>

            <th>Business</th>

            <th>Owner</th>

            <th>Type</th>

            <th>Contact</th>

            <th>Location</th>

            <th>Status</th>

            <th>Applied</th>

            <th>Action</th>

          </tr>

        </thead>

        <tbody>

          {providers.map((provider) => (

            <tr key={provider._id}>

              {/* Business */}

              <td>

                <div className="provider-info">

                 <img
  className="provider-avatar"
  src={
    provider.photos?.profilePhoto
      ? getImageUrl(
          `/uploads/provider/${provider.photos.profilePhoto}`
        )
      : "/images/default-user.png"
  }
  alt={
    provider.business?.businessName ||
    "Provider"
  }
  onError={(e) => {
    e.currentTarget.src =
      "/images/default-user.png";
  }}
/>

                  <div>

                    <h4>

                      {provider.business?.businessName ||
                        "Unnamed Business"}

                    </h4>

                    <span>

                      {provider.providerType}

                    </span>

                  </div>

                </div>

              </td>

              {/* Owner */}

              <td>

                <div className="owner-info">

                  <strong>

                    {provider.ownerName}

                  </strong>

                  <span>

                    <Mail size={14} />

                    {provider.email}

                  </span>

                </div>

              </td>

              {/* Type */}

              <td>

                {provider.providerType}

              </td>

              {/* Contact */}

              <td>

                <div className="contact-info">

                  <Phone size={14} />

                  {provider.phone}

                </div>

              </td>

              {/* Location */}

              <td>

                <div className="location-info">

                  <MapPin size={14} />

                  {provider.address?.city || "Not Available"}

                </div>

              </td>

              {/* Status */}

              <td>

                <ProviderStatusBadge
                  status={provider.status}
                />

              </td>

              {/* Applied */}

              <td>

                {new Date(
                  provider.createdAt
                ).toLocaleDateString("en-IN")}

              </td>

              {/* Action */}

              <td>

                <button
                  className="view-details-btn"
                  onClick={() =>
                    navigate(`/admin/providers/${provider._id}`)
                  }
                >

                  <Eye size={16} />

                  <span>

                    View

                  </span>

                </button>

              </td>

            </tr>

          ))}

        </tbody>

      </table>

    </div>

  );

}

export default ProviderTable;